const GUEST_QUERY_PARAM = 'guest';

const GuestAccessService = {
	/**
	 * Decode a base64url string back to standard base64.
	 * Replaces - with +, _ with /, and adds back = padding.
	 */
	_base64UrlDecode(base64url) {
		let base64 = base64url.replace(/-/g, '+').replace(/_/g, '/');
		const pad = base64.length % 4;
		if( pad ) {
			base64 += '='.repeat(4 - pad);
		}
		return window.atob(base64);
	},

	decodeCode(code) {
		try {
			const payload = JSON.parse(this._base64UrlDecode(code));

			if( typeof payload?.username !== 'string' || typeof payload?.token !== 'string' ) {
				throw new Error('invalid-code');
			}

			return payload;
		}
		catch{
			return null;
		}
	},

	getCodeFromUrl() {
		return new URLSearchParams(window.location.search).get(GUEST_QUERY_PARAM);
	},

	getDestinationUrl() {
		const url = new URL(window.location.href);
		url.searchParams.delete(GUEST_QUERY_PARAM);

		return `${url.pathname}${url.search}${url.hash}`;
	},

	removeCodeFromUrl() {
		window.history.replaceState({}, document.title, GuestAccessService.getDestinationUrl());
	}
};

export default GuestAccessService;
